export class GradeInventoryIdReq {
    gradeInventoryId : number

    constructor( gradeInventoryId : number) {
        this.gradeInventoryId = gradeInventoryId;
    }
}